const Icons = {
  PriceChangeYellow: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1002_225)">
        <path
          d="M2 21L11 12"
          stroke="#FCA800"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path d="M4.5 7H8" stroke="#FCA800" strokeLinecap="round" />
        <path d="M4.5 8.5H8" stroke="#FCA800" strokeLinecap="round" />
        <path
          d="M14 15L11 12"
          stroke="#FCA800"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M14 15C14 15 18.7692 10.4286 22 7M22 7H17.5M22 7V9.28572V11"
          stroke="#FCA800"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M10.4753 5.23677C9.12591 4.00144 7.12942 3.98593 6.01601 5.20213C4.9026 6.41834 5.09389 8.4057 6.44327 9.64104C7.79265 10.8764 9.63647 10.752 10.7499 9.53584"
          stroke="#FCA800"
          strokeLinecap="round"
        />
        <path
          d="M14.2988 10.4404C15.8699 7.10321 14.5075 3.15693 11.2558 1.62615C8.00415 0.0953634 4.09457 1.55975 2.52352 4.89694C0.952464 8.23413 2.49274 11.8028 5.7444 13.3336"
          stroke="#FCA800"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1002_225">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  PriceChangeBlack: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1002_209)">
        <path
          d="M2 21L11 12"
          stroke="#1A273D"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path d="M4.5 7H8" stroke="#1A273D" strokeLinecap="round" />
        <path d="M4.5 8.5H8" stroke="#1A273D" strokeLinecap="round" />
        <path
          d="M14 15L11 12"
          stroke="#1A273D"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M14 15C14 15 18.7692 10.4286 22 7M22 7H17.5M22 7V9.28572V11"
          stroke="#1A273D"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M10.4753 5.23677C9.12591 4.00144 7.12942 3.98593 6.01601 5.20213C4.9026 6.41834 5.09389 8.4057 6.44327 9.64104C7.79265 10.8764 9.63647 10.752 10.7499 9.53584"
          stroke="#1A273D"
          strokeLinecap="round"
        />
        <path
          d="M14.2988 10.4404C15.8699 7.10321 14.5075 3.15693 11.2558 1.62615C8.00415 0.0953634 4.09457 1.55975 2.52352 4.89694C0.952464 8.23413 2.49274 11.8028 5.7444 13.3336"
          stroke="#1A273D"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1002_209">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  ForecastsYellow: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1003_51)">
        <path
          d="M2 21L11 12"
          stroke="#FCA800"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M14 15L11 12"
          stroke="#FCA800"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M14 15C14 15 18.7692 10.4286 22 7M22 7H17.5M22 7V9.28572V11"
          stroke="#FCA800"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M14.2988 10.4404C15.8699 7.10321 14.5075 3.15693 11.2558 1.62615C8.00415 0.0953634 4.09457 1.55975 2.52352 4.89694C0.952464 8.23413 2.49274 11.8028 5.7444 13.3336"
          stroke="#FCA800"
          strokeLinecap="round"
        />
        <path
          d="M7.41 8.71L7.37 7.1H7.87C8.11667 7.1 8.34667 7.08333 8.56 7.05C8.78 7.01667 8.97 6.96333 9.13 6.89C9.29 6.81 9.41333 6.69667 9.5 6.55C9.59333 6.40333 9.64 6.21667 9.64 5.99C9.64 5.79 9.6 5.62 9.52 5.48C9.44 5.33333 9.32667 5.22333 9.18 5.15C9.03333 5.07 8.85667 5.03 8.65 5.03C8.44333 5.03 8.26333 5.07 8.11 5.15C7.96333 5.23 7.85 5.34 7.77 5.48C7.69 5.62 7.65 5.78667 7.65 5.98H6.33C6.32333 5.58 6.41333 5.22333 6.6 4.91C6.78667 4.59 7.05667 4.34 7.41 4.16C7.76333 3.97333 8.18667 3.88 8.68 3.88C9.13333 3.88 9.53333 3.96333 9.88 4.13C10.2267 4.29 10.5 4.52667 10.7 4.84C10.9 5.15333 11 5.53667 11 5.99C11 6.43667 10.9 6.81333 10.7 7.12C10.5067 7.42 10.2367 7.64333 9.89 7.79C9.54333 7.93667 9.14 8.01333 8.68 8.02L8.65 8.71H7.41ZM8.04 11.05C7.78667 11.05 7.58 10.9733 7.42 10.82C7.26 10.66 7.18 10.47 7.18 10.25C7.18 10.0233 7.26 9.83333 7.42 9.68C7.58 9.52667 7.78667 9.45 8.04 9.45C8.29333 9.45 8.49667 9.52667 8.65 9.68C8.81 9.83333 8.89 10.0233 8.89 10.25C8.89 10.47 8.81 10.66 8.65 10.82C8.49667 10.9733 8.29333 11.05 8.04 11.05Z"
          fill="#FCA800"
        />
      </g>
      <defs>
        <clipPath id="clip0_1003_51">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  ForecastsBlack: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1003_58)">
        <path
          d="M2 21L11 12"
          stroke="#1A273D"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M14 15L11 12"
          stroke="#1A273D"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M14 15C14 15 18.7692 10.4286 22 7M22 7H17.5M22 7V9.28572V11"
          stroke="#1A273D"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M14.2988 10.4404C15.8699 7.10321 14.5075 3.15693 11.2558 1.62615C8.00415 0.0953634 4.09457 1.55975 2.52352 4.89694C0.952464 8.23413 2.49274 11.8028 5.7444 13.3336"
          stroke="#1A273D"
          strokeLinecap="round"
        />
        <path
          d="M7.41 8.71L7.37 7.1H7.87C8.11667 7.1 8.34667 7.08333 8.56 7.05C8.78 7.01667 8.97 6.96333 9.13 6.89C9.29 6.81 9.41333 6.69667 9.5 6.55C9.59333 6.40333 9.64 6.21667 9.64 5.99C9.64 5.79 9.6 5.62 9.52 5.48C9.44 5.33333 9.32667 5.22333 9.18 5.15C9.03333 5.07 8.85667 5.03 8.65 5.03C8.44333 5.03 8.26333 5.07 8.11 5.15C7.96333 5.23 7.85 5.34 7.77 5.48C7.69 5.62 7.65 5.78667 7.65 5.98H6.33C6.32333 5.58 6.41333 5.22333 6.6 4.91C6.78667 4.59 7.05667 4.34 7.41 4.16C7.76333 3.97333 8.18667 3.88 8.68 3.88C9.13333 3.88 9.53333 3.96333 9.88 4.13C10.2267 4.29 10.5 4.52667 10.7 4.84C10.9 5.15333 11 5.53667 11 5.99C11 6.43667 10.9 6.81333 10.7 7.12C10.5067 7.42 10.2367 7.64333 9.89 7.79C9.54333 7.93667 9.14 8.01333 8.68 8.02L8.65 8.71H7.41ZM8.04 11.05C7.78667 11.05 7.58 10.9733 7.42 10.82C7.26 10.66 7.18 10.47 7.18 10.25C7.18 10.0233 7.26 9.83333 7.42 9.68C7.58 9.52667 7.78667 9.45 8.04 9.45C8.29333 9.45 8.49667 9.52667 8.65 9.68C8.81 9.83333 8.89 10.0233 8.89 10.25C8.89 10.47 8.81 10.66 8.65 10.82C8.49667 10.9733 8.29333 11.05 8.04 11.05Z"
          fill="#1A273D"
        />
      </g>
      <defs>
        <clipPath id="clip0_1003_58">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  AlertYellow: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1044_122)">
        <path
          d="M12 5.5C14.7614 5.5 17 7.73858 17 10.5V12.7396C17 13.2294 17.1798 13.7022 17.5052 14.0683L18.7808 15.5035C19.6407 16.4708 18.954 18 17.6597 18H6.34025C5.04598 18 4.35927 16.4708 5.21913 15.5035L6.4948 14.0683C6.82022 13.7022 6.99998 13.2294 6.99998 12.7396L7 10.5C7 7.73858 9.23858 5.5 12 5.5ZM12 5.5V3M10.9999 21H12.9999"
          stroke="#FCA800"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.5 4C5.7519 4.35802 4.15872 6.88042 4.5 9.5"
          stroke="#FCA800"
          strokeLinecap="round"
        />
        <path
          d="M19.6061 9.1604C20.0713 6.42841 18.1284 4.1644 15.5242 3.72091"
          stroke="#FCA800"
          strokeLinecap="round"
        />
        <path
          d="M6.5 2C3.7519 2.35802 1.65872 6.38042 2 9"
          stroke="#FCA800"
          strokeLinecap="round"
        />
        <path
          d="M22 8.5C22.7503 5.83217 20.0431 2.21518 17.5 1.5"
          stroke="#FCA800"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1044_122">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  AlertBlack: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1044_130)">
        <path
          d="M12 5.5C14.7614 5.5 17 7.73858 17 10.5V12.7396C17 13.2294 17.1798 13.7022 17.5052 14.0683L18.7808 15.5035C19.6407 16.4708 18.954 18 17.6597 18H6.34025C5.04598 18 4.35927 16.4708 5.21913 15.5035L6.4948 14.0683C6.82022 13.7022 6.99998 13.2294 6.99998 12.7396L7 10.5C7 7.73858 9.23858 5.5 12 5.5ZM12 5.5V3M10.9999 21H12.9999"
          stroke="#1A273D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.5 4C5.7519 4.35802 4.15872 6.88042 4.5 9.5"
          stroke="#1A273D"
          strokeLinecap="round"
        />
        <path
          d="M19.6061 9.1604C20.0713 6.42841 18.1284 4.1644 15.5242 3.72091"
          stroke="#1A273D"
          strokeLinecap="round"
        />
        <path
          d="M6.5 2C3.7519 2.35802 1.65872 6.38042 2 9"
          stroke="#1A273D"
          strokeLinecap="round"
        />
        <path
          d="M22 8.5C22.7503 5.83217 20.0431 2.21518 17.5 1.5"
          stroke="#1A273D"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1044_130">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  WeeklySummaryYellow: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 7V3M16 7V3M8.01 10H8M8.01 13H8M8.01 16H8M12.01 13H12M12.01 10H12M16.01 13H16M12.01 16H12M16.01 10H16M6 21H18C19.6569 21 21 19.6569 21 18V8C21 6.34315 19.6569 5 18 5H6C4.34315 5 3 6.34315 3 8V18C3 19.6569 4.34315 21 6 21Z"
        stroke="#DB9E21"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  WeeklySummaryBlack: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 7V3M16 7V3M8.01 10H8M8.01 13H8M8.01 16H8M12.01 13H12M12.01 10H12M16.01 13H16M12.01 16H12M16.01 10H16M6 21H18C19.6569 21 21 19.6569 21 18V8C21 6.34315 19.6569 5 18 5H6C4.34315 5 3 6.34315 3 8V18C3 19.6569 4.34315 21 6 21Z"
        stroke="#1A273D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

export default Icons;
